import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Wrench, AlertTriangle, CheckCircle } from 'lucide-react';
import './MaintenanceTab.css';

const MaintenanceTab = ({ hotelId, token }) => {
  const [issues, setIssues] = useState([]);
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState({});

  useEffect(() => {
    if (hotelId && token) {
      fetchIssues();
      fetchStats();
    }
  }, [hotelId, token]);

  const fetchIssues = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/maintenance`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setIssues(response.data);
      setLoading(false);
    } catch (err) {
      console.error('Error fetching maintenance issues:', err);
      setLoading(false);
    }
  };

  const fetchStats = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/maintenance/stats`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setStats(response.data);
    } catch (err) {
      console.error('Error fetching stats:', err);
    }
  };

  const getPriorityColor = (priority) => {
    const colors = {
      urgent: '#dc2626',
      high: '#ef4444',
      medium: '#f59e0b',
      low: '#10b981'
    };
    return colors[priority] || '#6b7280';
  };

  if (loading) {
    return <div className="tab-loading"><div className="loading-spinner"></div><p>Loading maintenance issues...</p></div>;
  }

  return (
    <div className="maintenance-tab">
      <div className="tab-header">
        <h2><Wrench size={24} /> Maintenance Management</h2>
      </div>

      <div className="stats-grid">
        <div className="stat-box"><span className="stat-value">{stats.total_issues || 0}</span><span className="stat-label">Total Issues</span></div>
        <div className="stat-box"><span className="stat-value">{stats.reported_issues || 0}</span><span className="stat-label">Reported</span></div>
        <div className="stat-box"><span className="stat-value">{stats.in_progress_issues || 0}</span><span className="stat-label">In Progress</span></div>
        <div className="stat-box"><span className="stat-value">{stats.completed_issues || 0}</span><span className="stat-label">Completed</span></div>
      </div>

      <div className="issues-list">
        {issues.map(issue => (
          <div key={issue.maintenance_id} className="issue-card">
            <div className="issue-header">
              <span className="room-number">Room {issue.room_number}</span>
              <span className="priority-badge" style={{ background: getPriorityColor(issue.priority) }}>
                {issue.priority}
              </span>
            </div>
            <div className="issue-body">
              <p className="issue-description">{issue.issue_description}</p>
              <div className="issue-meta">
                <p><strong>Status:</strong> {issue.status}</p>
                <p><strong>Reported:</strong> {new Date(issue.reported_date).toLocaleDateString()}</p>
                {issue.assigned_to_name && <p><strong>Technician:</strong> {issue.assigned_to_name}</p>}
                {issue.estimated_cost && <p><strong>Est. Cost:</strong> ${issue.estimated_cost}</p>}
              </div>
            </div>
          </div>
        ))}
      </div>

      {issues.length === 0 && <div className="empty-state"><Wrench size={48} /><h3>No Maintenance Issues</h3><p>All systems operational!</p></div>}
    </div>
  );
};

export default MaintenanceTab;
